import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.header');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-component-header',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.header/view.scss */
/* src/app/component.header/view.scss: no such file or directory */`],
})
export class ComponentHeaderComponent implements OnInit, DoCheck {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public currentUrl: any;
    public first = "";
    public second = "";
    public third = "";
    public menu: any;
    public currentMenu: any;

    public userMenu = [
        { label: "대시보드", path: "dashboard", isLink: true },
        { label: "기관현황", path: "institute", isLink: true },
        { label: "공지사항", path: "notice", isLink: false },
        { label: "마이페이지", path: "mypage", isLink: true }
    ];
    public noticeMenu = [
        { label: "알림", path: "alert", isLink: true },
        { label: "이용공지", path: "use", isLink: true }
    ];
    public instituteMenu = [
        { label: "정보", path: "info", isLink: true },
        { label: "이슈", path: "issue", isLink: true },
        { label: "문서함", path: "document", isLink: true },
        { label: "메모", path: "memo", isLink: true }
    ];
    public adminMenu = [
        { label: "사용자 관리", path: "users", isLink: true },
        { label: "기관 관리", path: "institute", isLink: true },
        { label: "이슈 관리", path: "issues", isLink: true },
        { label: "포트 관리", path: "ports", isLink: true },
        { label: "공지사항 관리", path: "notices", isLink: true },
        { label: "웨더맵 설정", path: "weathermap", isLink: true },
        { label: "가용률 설정", path: "availability", isLink: true },
        { label: "매뉴얼 관리", path: "manuals", isLink: true }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async ngDoCheck() {
        const url = this.router.url;
        if (this.currentUrl !== url) {
            this.currentUrl = url;
            this.second = this.third = '';
            let segment = url.split('/').filter(Boolean);

            if (url.includes("admin")) {
                this.menu = this.adminMenu;
                segment = segment.slice(1);
            } else {
                this.menu = this.userMenu;
            }

            this.first = this.menu.find(item => url.includes(item.path)).label || '';

            if (segment.length > 1) {
                if (["기관현황", "기관 관리"].includes(this.first)) this.second = this.instituteMenu.find(item => url.includes(item.path)).label || '';
                // else if (["공지사항", "공지사항 관리"].includes(this.first)) this.second = this.noticeMenu.find(item => url.includes(item.path)).label || '';
                else if (["공지사항"].includes(this.first)) this.second = this.noticeMenu.find(item => url.includes(item.path)).label || '';

                if (segment.length > 2) {
                    const exclude = ['info', 'issue', 'document', 'alert', 'use', 'memo'];
                    if ((["기관현황", "기관 관리"].includes(this.first) && !exclude.includes(segment[-2])) || (["공지사항", "공지사항 관리"].includes(this.first) && !exclude.includes(segment[-1]))) {
                        this.third = "상세보기";
                    }
                }
            }
            await this.service.render();
        }
    }
}

export default ComponentHeaderComponent;